export const plazaGraphsActionTypes = (prefix) => {
  if (!prefix) {
    throw new Error('Prefix is required in plazaGraphsActionTypes');
  }

  return {
    SET_DEFAULT_VALUES: `${prefix}SET_DEFAULT_VALUES`,
    SET_PLAZA_LIST: `${prefix}SET_PLAZA_LIST`,
    RESET_RT_STATE: `${prefix}RESET_RT_STATE`,
    SET_NODES: `${prefix}SET_NODES`,
    SET_METER_MODEL: `${prefix}SET_METER_MODEL`,
    CLEAR_NODES: `${prefix}CLEAR_NODES`,
    SET_IS_FETCHING: `${prefix}SET_IS_FETCHING`,
    SET_TOPOLOGY_NODES: `${prefix}SET_TOPOLOGY_NODES`,
    SET_CONSTRAINTS_DATA: `${prefix}SET_CONSTRAINTS_DATA`,
    SET_CHARGERS_DATA: `${prefix}SET_CHARGERS_DATA`,
    SET_METER_DATA: `${prefix}SET_METER_DATA`,
    SET_TOTALS_DATA: `${prefix}SET_TOTALS_DATA`,
    CLEAR_TIME_SERIES: `${prefix}CLEAR_TIME_SERIES`,
    SET_TIME_ZONE: `${prefix}SET_TIME_ZONE`,
    SET_PLAZA: `${prefix}SET_PLAZA`,
    RESET: `${prefix}RESET`,
  };
};
